import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DefaultResponseWithData } from '../models/system';
import { ISupplier } from '../models/Supplier';
import useApiHelper from '../hooks/useApiHelper';

export default function useSuppliers() {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();

  const suppliers = useQuery({
    queryKey: ['suppliers'],
    queryFn: () => get<DefaultResponseWithData<ISupplier[]>>(`/supplier`)
  });

  const create = useMutation(
    (supplier: any) => post("/supplier", supplier),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["suppliers"]);
      },
    }
  );

  const sync = useMutation(
    (supplier: any) => post("/supplier/sync", supplier),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["suppliers"]);
      },
    }
  );

  return {
    suppliers,
    create,
    sync
  };
}